"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const ads_1 = require("./ads");
const contexts_1 = require("./contexts");
exports.emailTemplateBlockListDetails = graphql_tag_1.default `
  fragment emailTemplateBlockListDetails on EmailTemplateBlock {
    id
    type
    socialProvider
    name
    clientId
    displayName
  }
`;
exports.emailTemplateBlockDetailsCore = graphql_tag_1.default `
  fragment emailTemplateBlockDetailsCore on EmailTemplateBlock {
    attrKeys
    attrs
    availableTargets
    basicProcessing
    canBeConverted
    clientId
    socialProvider
    contentFieldKey
    contentItem
    contentSlotNumber
    contentStr
    datetimeFormat
    displayName
    fieldName
    fieldType
    fieldTypes
    hidden
    hideable
    id
    lockable
    locked
    name
    order
    outerHTML
    selectedTargets
    type
    unwrap
    usingRichContentEditor
    ad {
      ...adDetailData
    }
    adContexts {
      ...contextDetailData
    }
    isInstance
    instanceOf {
      id
    }
    repeatOf {
      id
    }
    contentFeed {
      id
      name
      contentMapping {
        id
        name
      }
      contentSystem {
        id
        name
      }
    }
  }
  ${exports.emailTemplateBlockListDetails}
  ${ads_1.adDetailData}
  ${contexts_1.contextDetailData}
`;
exports.emailTemplateBlockDetails = graphql_tag_1.default `
  fragment emailTemplateBlockDetails on EmailTemplateBlock {
    ...emailTemplateBlockDetailsCore
    childBlocks {
      ...emailTemplateBlockDetailsCore
      childBlocks {
        ...emailTemplateBlockDetailsCore
        childBlocks {
          ...emailTemplateBlockDetailsCore
          childBlocks {
            ...emailTemplateBlockDetailsCore
          }
        }
      }
    }
    parentBlock {
      ...emailTemplateBlockListDetails
    }
  }
  ${exports.emailTemplateBlockDetailsCore}
`;
//# sourceMappingURL=emailTemplateBlocks.js.map